import { format, isValid } from 'date-fns';

import getDateFromISO from './getDateISO';

// dateFormat is a date-fns pattern, normally useDateLocale().dateFormat.
const formatDate = (
  dateISO: string | null | undefined,
  dateFormat: string
): string => {
  if (!dateISO) {
    return '-';
  }

  const date = getDateFromISO(dateISO);
  return isValid(date) ? format(date, dateFormat) : '-';
};

export default formatDate;
